export enum ScorecardTabs {
  Highlights = 'Highlights',
  Summary = 'Summary',
  KeyMoments = 'Key Moments',
}
